'use client';

import type { JSX } from 'react';
import { UspWrapper } from './UspWrapper.client';
import { useUspData } from '../../hooks/useUspData';

/**
 * Usp Component: Unique Selling Point
 *
 * @param data Object contains data
 * @returns {JSX.Element|null} to be placed in @apps/shopping pages or null if no data exist
 */
export const Usp = (): JSX.Element | null => {
  const data = useUspData();

  if (data) {
    return <UspWrapper data={data} />;
  }

  return null;
};
